import React, { useEffect } from "react";
import {
  ActionPerformed,
  PushNotificationSchema,
} from "@capacitor/push-notifications";
import { useNavigate } from "react-router";

function PushHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    registerForPush();
  }, []);

  const registerForPush = async () => {
    if (import.meta.env.VITE_PLATFORM === "mobile") {
      const { PushNotifications } = await import(
        "@capacitor/push-notifications"
      );

      PushNotifications.addListener(
        "pushNotificationReceived",
        (notification: PushNotificationSchema) => {
          //
        }
      );

      PushNotifications.addListener(
        "pushNotificationActionPerformed",
        (notification: any) => {

          if (notification.notification.data.url && notification.notification.data.url.length > 0) {
            const target = notification.notification.data.url.replace(
              "https://givin.gifts/open",
              ""
            );

            navigate(target);
          }
        }
      );
    }
  };

  return <></>;
}

export default PushHandler;
